import { render, staticRenderFns } from "./PDPOverviewDescription.vue?vue&type=template&id=e6888d82&scoped=true"
import script from "./PDPOverviewDescription.vue?vue&type=script&lang=js"
export * from "./PDPOverviewDescription.vue?vue&type=script&lang=js"
import style0 from "./PDPOverviewDescription.vue?vue&type=style&index=0&id=e6888d82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6888d82",
  null
  
)

export default component.exports